<template>
    <div v-if="themeStore.themeIndex === 1">
        <LevelViewOne ref="levelRef" :data-set="dataSet" @userRankDailyCheckin="userRankDailyCheckin" />
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <LevelViewTwo ref="levelRef" :data-set="dataSet" @userRankDailyCheckin="userRankDailyCheckin" />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <LevelViewThree ref="levelRef" :data-set="dataSet" @userRankDailyCheckin="userRankDailyCheckin" />
    </div>
    <div v-if="themeStore.themeIndex === 4">
        <LevelViewFour ref="levelRef" :data-set="dataSet" @userRankDailyCheckin="userRankDailyCheckin" />
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { getActivityInformations } from '@/api/common';
import { getUserRankDailyCheckin } from '@/api/level';
import LevelViewOne from '@/themes/themeOne/level/levelView.vue';
import LevelViewTwo from '@/themes/themeTwo/level/levelView.vue';
import LevelViewThree from '@/themes/themeThree/level/levelView.vue';
import LevelViewFour from '@/themes/themeFour/level/levelView.vue';
import { onMounted, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { LevelViewData, RankConfig, RankItem, RewardItem } from './supportScript';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useThemeStore } from '@/stores/theme';

const { t } = useI18n();

const levelRef = ref()
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const themeStore = useThemeStore()

const isLoading = ref(false)
const activityInfo = ref([])
const rewardsList = ref<RewardItem[]>([])
const levelList = ref<RankItem[]>([])
const rankConfig = ref<RankConfig>({
    ranksConfigData: {
        rank_list: [],
    },
    rank: 0,
    rewardData: {
        rewards: []
    },
    amount: 0
})
const activeRank = ref(0)
const currentRankName = ref('')
const currentRankIcon = ref('')
const totalTurnover = ref(0)

const dataSet = computed<LevelViewData>(() => ({
    activityInfo: activityInfo.value,
    isLoading: isLoading.value,
    rewardsList: rewardsList.value,
    levelList: levelList.value,
    rankConfig: rankConfig.value,
    activeRank: activeRank.value,
    currentRankName: currentRankName.value,
    currentRankIcon: currentRankIcon.value,
    totalTurnover: totalTurnover.value
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getLevelInformations = () => {
    let data = {
        activityId: "USER_RANK"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        levelRef.value.isLoadingFalse()
        let resdata = res.data
        rankConfig.value = resdata.config
        levelList.value = rankConfig.value.ranksConfigData.rank_list
        activeRank.value = rankConfig.value.rank
        activityInfo.value = JSON.parse(resdata.activityIntro);
        rewardsList.value = rankConfig.value.rewardData.rewards
        currentRankName.value = levelList.value.find(item => item.rank == activeRank.value)?.rank_name || ''
        currentRankIcon.value = levelList.value.find(item => item.rank == activeRank.value)?.icon2 || ''
        totalTurnover.value = resdata?.totalTurnover || 0
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const userRankDailyCheckin = () => {
    levelRef.value.isLoadingTrue()
    getUserRankDailyCheckin().then(res => {
        let resdata = res.data
        showSuccess(res.msg)
        setTimeout(() => {
            getLevelInformations()
        }, 300)
    }).catch(err => {
        showError(err);
        levelRef.value.isLoadingFalse()
    })
}

onMounted(() => {
    loadingRef.value.open()
    getLevelInformations()
})
</script>
<style scoped>
.level_container {
    padding: 70px 0;
    --cell-min-width: 65px;

}

.top_card {
    margin: 0 20px;
    position: relative;
}

.top_card img {
    width: 100%;

}

.top_content img {
    width: 145px;
    position: absolute;
    top: 15px;
    right: 5px;
}

.text_1 {
    color: rgba(0, 0, 0, 0.65);
    font-size: 13px;
    opacity: 0.8;
}

.level_text {
    position: absolute;
    top: 15px;
    left: 20px;
}

.text_2 {
    color: #000000;
    font-size: 22px;
    font-weight: 700;
}

.level_name {
    position: absolute;
    top: 35px;
    left: 20px;
}

.value_text {
    position: absolute;
    width: 200px;
    top: 90px;
    left: 20px;
}

.value {
    position: absolute;
    top: 130px;
    left: 20px;
}

.level_scroll_wrapper {
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin: 0 5%;
    padding-bottom: 6px;
}

.level_scroll_wrapper::-webkit-scrollbar {
    display: none;
}


.level_list {
    display: flex;
    align-items: center;
    min-width: max-content;
    padding: 25px 0 8px;
    flex-direction: row;
    text-align: center;
    color: rgba(255, 255, 255, 0.45);
    overflow-x: auto;
    white-space: nowrap;
    gap: 8.5px;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.level_list::-webkit-scrollbar {
    display: none;
}

.level_cell {
    flex: 0 0 var(--level-cell-width);
    min-width: var(--cell-min-width);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.level_item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    padding: 6px 6px;
    box-sizing: border-box;
}

.level_item img {
    width: 50px;
    height: auto;
    display: block;
}

.level_item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    padding: 6px 6px;
    box-sizing: border-box;
    flex-direction: row;
}

.level_item img {
    height: auto;
    display: block;
    width: 45px;
}

.level_label {
    margin-top: 6px;
    text-align: center;
    color: rgba(255, 255, 255, 0.45);
    font-size: 12px;
    width: 100%;
    word-break: break-word;
}

.manual_level_bar {
    display: flex;
    align-items: center;
    min-width: max-content;
    gap: 0;
    padding: 6px 0 0;
}

.manual_level_bar {
    display: flex;
    align-items: center;
    min-width: max-content;
    gap: 0;
    padding: 6px 0 0;
}

.step_line.left {
    width: calc(var(--level-cell-width) / 2);
    height: 0.5px;
    background-color: rgba(255, 255, 255, 0.15);
    margin-right: 4px;
}

.step_line.left.active {
    background-color: #F9C486;
}

.level_step {
    flex: 0 0 var(--level-cell-width);
    min-width: var(--cell-min-width);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;
}

.connector {
    position: absolute;
    top: 6px;
    left: 50%;
    width: calc(var(--level-cell-width));
    height: 0.5px;
    background-color: rgba(255, 255, 255, 0.15);
    z-index: 1;
}

.connector.active {
    background-color: #F9C486;
}

.step_dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.15);
    z-index: 2;
}

.step_dot2 {
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.15);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.level_step.active .step_dot {
    background-color: #F9C486;
}

.level_step.active .step_dot2 {
    background-color: transparent;
}

.step_label {
    z-index: 3;
    text-align: center;
    font-size: 13.5px;
    margin-top: 4px;
    color: rgba(255, 255, 255, 0.35);
}

.level_step.active .step_label {
    color: #F9C486;
}

.step_line {
    position: absolute;
    top: 6px;
    left: 50%;
    width: 100%;
    height: 0.5px;
    background-color: rgba(255, 255, 255, 0.15);
    ;
    z-index: 1;
}

.step_line.active {
    background-color: #F9C486;
}

.middle_container {
    padding: 15px 25px;
}

.middle_container img {
    width: 100%;
}

.label_container {
    padding: 0 25px;
}

.label_container img {
    width: 100%;
}

.label_text {
    margin: -75px 0 10px
}

.checkingDoneTick {
    display: flex;
    justify-content: right;
    align-items: center;
}

.checkingDoneTick img {
    width: 12px;
}

.day_text {
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    padding-left: 10px;
    display: flex;
    align-items: center;
}

.currency_text {
    font-size: 14px;
    color: #fff;
    font-weight: 500;
    padding-left: 10px;
    display: flex;
    align-items: center;
}

.currency_text span {
    color: #FFE400;
    font-size: 18px;
    padding-left: 5px;
}

.label_img {
    display: flex;
    justify-content: center;
}

.label_img img {
    width: 140px;
}

.activeText {
    /* padding: 20px 20px 20px 35px; */
    font-size: 14px;
    color: #00FFFF;
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.select_icon {
    display: flex;
    justify-content: center;
}

.select_icon img {
    width: 18px;
    padding: 20px;
}

.step_line.left {
    position: absolute;
    top: 6px;
    left: 15px;
    width: calc(50% / 6);
    height: 0.5px;
    background-color: #F9C486;
    z-index: 1;
}

.active_level {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

@media (min-width: 400px) {
    .level_item {
        /* image stays the same, cell width still controlled by var */
        width: 100%;
    }
}
</style>